import type { DateValue } from "react-aria-components";
import {
  Calendar as RACCalendar,
  CalendarCell as RACCalendarCell,
  type CalendarCellProps as RACCalendarCellProps,
  CalendarGrid as RACCalendarGrid,
  CalendarGridBody as RACCalendarGridBody,
  type CalendarGridBodyProps as RACCalendarGridBodyProps,
  CalendarGridHeader as RACCalendarGridHeader,
  type CalendarGridHeaderProps as RACCalendarGridHeaderProps,
  type CalendarGridProps as RACCalendarGridProps,
  CalendarHeaderCell as RACCalendarHeaderCell,
  type CalendarHeaderCellProps as RACCalendarHeaderCellProps,
  CalendarMonthPicker as RACCalendarMonthPicker,
  type CalendarMonthPickerProps as RACCalendarMonthPickerProps,
  type CalendarProps as RACCalendarProps,
  CalendarYearPicker as RACCalendarYearPicker,
  type CalendarYearPickerProps as RACCalendarYearPickerProps,
  Heading as RACHeading,
  type HeadingProps as RACHeadingProps,
} from "react-aria-components";

export interface CalendarProps<T extends DateValue> extends RACCalendarProps<T> {}
export interface CalendarGridProps extends RACCalendarGridProps {}
export interface CalendarGridHeaderProps extends RACCalendarGridHeaderProps {}
export interface CalendarGridBodyProps extends RACCalendarGridBodyProps {}
export interface CalendarHeaderCellProps extends RACCalendarHeaderCellProps {}
export interface CalendarCellProps extends RACCalendarCellProps {}
export interface CalendarHeadingProps extends RACHeadingProps {}
export interface CalendarMonthPickerProps extends RACCalendarMonthPickerProps {}
export interface CalendarYearPickerProps extends RACCalendarYearPickerProps {}

export function Calendar<T extends DateValue>(props: CalendarProps<T>) {
  return <RACCalendar {...props} />;
}

export function CalendarGrid(props: CalendarGridProps) {
  return <RACCalendarGrid {...props} />;
}

export function CalendarGridHeader(props: CalendarGridHeaderProps) {
  return <RACCalendarGridHeader {...props} />;
}

export function CalendarGridBody(props: CalendarGridBodyProps) {
  return <RACCalendarGridBody {...props} />;
}

export function CalendarHeaderCell(props: CalendarHeaderCellProps) {
  return <RACCalendarHeaderCell {...props} />;
}

export function CalendarCell(props: CalendarCellProps) {
  return <RACCalendarCell {...props} />;
}

export function CalendarHeading(props: CalendarHeadingProps) {
  return <RACHeading {...props} />;
}

export function CalendarMonthPicker(props: CalendarMonthPickerProps) {
  return <RACCalendarMonthPicker {...props} />;
}

export function CalendarYearPicker(props: CalendarYearPickerProps) {
  return <RACCalendarYearPicker {...props} />;
}
